import { getApiText, getApiTitle } from '../../../shared/i18n/locale';
import type { SubscriptionData } from './types';

/**
 * Localized plan title from merged subscription (`fetchSubscriptionData` shape).
 * Prefers bilingual detail fields, then top-level title / subscription_name.
 */
export function getSubscriptionPlanTitleFromMerged(
  sub: SubscriptionData | null | undefined,
  fallback: string,
): string {
  if (sub == null) {
    return fallback;
  }
  const detail = sub.detail ?? sub.subscription_detail;
  if (detail != null && typeof detail === 'object') {
    const d = detail as Record<string, unknown>;
    const from_api =
      getApiTitle(d) || getApiText(d, 'name', 'arabic_title') || getApiText(d, 'name', 'a_name');
    if (from_api) {
      return from_api;
    }
    const name = d.name;
    const title = d.title;
    if (typeof name === 'string' && name) {
      return name;
    }
    if (typeof title === 'string' && title) {
      return title;
    }
  }
  const top = sub.title;
  if (typeof top === 'string' && top.trim()) {
    return top.trim();
  }
  const sub_name = (sub as { subscription_name?: string }).subscription_name;
  if (typeof sub_name === 'string' && sub_name) {
    return sub_name;
  }
  return fallback;
}
